import React from 'react';
import { Slide, Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface Props {
  open: boolean;
  message: string;
  onClose(): void;
}

export const SucceedPaymentSnackbar: React.FC<Props> = ({ open, onClose, message }) => {
  const classes = useStyles();
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      TransitionComponent={Slide}
      autoHideDuration={4000}
    >
      <Alert severity="success" variant="filled" color="success" classes={{ filledSuccess: classes.filledSuccess }}>
        <AlertTitle>{message}</AlertTitle>
      </Alert>
    </Snackbar>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    filledSuccess: {
      background: 'var(--dark-green-status-success)'
    }
  })
);
